<button
    mat-button
    data-test="buttons-button"
    class="answer__button answer__button--multiple closecare-button primary-bg"
    [disabled]="disabled"
    [ngClass]="{'answer__button--nevative': button?.negative}"
    (click)="setAnswer(button.value)"
>
    {{button?.label}}
</button>